import { c as _c } from "react/compiler-runtime";
import { ExpandedSearchAccountResult } from "./ExpandedSearchAccountResult";
import { ExpandedSearchCollectionResult } from "./ExpandedSearchCollectionResult";
import { ExpandedSearchCurrencyResult } from "./ExpandedSearchCurrencyResult";
import { ExpandedSearchItemResult } from "./ExpandedSearchItemResult";
import { ExpandedSearchLinkResult } from "./ExpandedSearchLinkResult";
import { ExpandedSearchRecentResult } from "./ExpandedSearchRecentResult";
export function ExpandedSearchResultItem(t0) {
  const $ = _c(24);
  const {
    item,
    selected,
    onSelect
  } = t0;
  switch (item.type) {
    case "link":
      {
        let t1;
        if ($[0] !== item || $[1] !== onSelect || $[2] !== selected) {
          t1 = <ExpandedSearchLinkResult item={item} onSelect={onSelect} selected={selected} />;
          $[0] = item;
          $[1] = onSelect;
          $[2] = selected;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "account":
      {
        let t1;
        if ($[4] !== item || $[5] !== onSelect || $[6] !== selected) {
          t1 = <ExpandedSearchAccountResult item={item} onSelect={onSelect} selected={selected} />;
          $[4] = item;
          $[5] = onSelect;
          $[6] = selected;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "collection":
      {
        let t1;
        if ($[8] !== item || $[9] !== onSelect || $[10] !== selected) {
          t1 = <ExpandedSearchCollectionResult item={item} onSelect={onSelect} selected={selected} />;
          $[8] = item;
          $[9] = onSelect;
          $[10] = selected;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case "recent-search":
      {
        let t1;
        if ($[12] !== item || $[13] !== onSelect || $[14] !== selected) {
          t1 = <ExpandedSearchRecentResult item={item} onSelect={onSelect} selected={selected} />;
          $[12] = item;
          $[13] = onSelect;
          $[14] = selected;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case "item":
      {
        let t1;
        if ($[16] !== item || $[17] !== onSelect || $[18] !== selected) {
          t1 = <ExpandedSearchItemResult item={item} onSelect={onSelect} selected={selected} />;
          $[16] = item;
          $[17] = onSelect;
          $[18] = selected;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case "currency":
      {
        let t1;
        if ($[20] !== item || $[21] !== onSelect || $[22] !== selected) {
          t1 = <ExpandedSearchCurrencyResult item={item} onSelect={onSelect} selected={selected} />;
          $[20] = item;
          $[21] = onSelect;
          $[22] = selected;
          $[23] = t1;
        } else {
          t1 = $[23];
        }
        return t1;
      }
  }
}